import { render, staticRenderFns } from "./ChooseUnity-comp.vue?vue&type=template&id=62d449ba&scoped=true&"
import script from "./ChooseUnity-comp.vue?vue&type=script&lang=js&"
export * from "./ChooseUnity-comp.vue?vue&type=script&lang=js&"
import style0 from "./ChooseUnity-comp.vue?vue&type=style&index=0&id=62d449ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d449ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
